import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "config/config";

export const fetchEnquiries = createAsyncThunk(
  "enquiry/fetchEnquiries",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${config.backendPath}/api/enquiry/get`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response && error.response.data.message
          ? error.response.data.message
          : "Failed to fetch enquiries. Please try again."
      );
    }
  }
);
export const deleteEnquiry = createAsyncThunk(
  "enquiry/deleteEnquiry",
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${config.backendPath}/api/enquiry/delete/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to delete enquiry."
      );
    }
  }
);


const enquirySlice = createSlice({
  name: "enquiry",
  initialState: {
    enquiries: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEnquiries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEnquiries.fulfilled, (state, action) => {
        state.loading = false;
        state.enquiries = action.payload;
      })
      .addCase(fetchEnquiries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteEnquiry.fulfilled, (state, action) => {
        state.enquiries = state.enquiries.filter(
          (enquiry) => enquiry._id !== action.payload
        );
      })
      .addCase(deleteEnquiry.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default enquirySlice.reducer;
